import React, { FC } from 'react';
import s from './paymentHistoryItem.module.scss';
import cn from 'classnames';
import Skeleton from 'react-loading-skeleton';
interface Props {}
export const PaymentHistoryItemLoader: FC<Props> = ({}) => {
  return <div className={s.paymentHistoryItem} data-sentry-component="PaymentHistoryItemLoader" data-sentry-source-file="PaymentHistoryItemLoader.tsx">
            <div className={s.paymentHistoryItem__body}>
                <div className={s.paymentHistoryItem__left}>
                    <Skeleton width={32} height={32} baseColor={'var(--White-Edgar)'} highlightColor={'var(--Brainstem-Grey)'} data-sentry-element="Skeleton" data-sentry-source-file="PaymentHistoryItemLoader.tsx" />
                    <div className={s.paymentHistoryItem__info}>
                        <div className={cn(s.paymentHistoryItem__title, '_ellipsis')}>
                            <Skeleton width={100} height={16} baseColor={'var(--White-Edgar)'} highlightColor={'var(--Brainstem-Grey)'} data-sentry-element="Skeleton" data-sentry-source-file="PaymentHistoryItemLoader.tsx" />
                        </div>
                        <div className={cn(s.paymentHistoryItem__text, '_ellipsis')}>
                            <Skeleton width={150} height={13} baseColor={'var(--White-Edgar)'} highlightColor={'var(--Brainstem-Grey)'} data-sentry-element="Skeleton" data-sentry-source-file="PaymentHistoryItemLoader.tsx" />
                        </div>
                    </div>
                </div>
                <div className={s.paymentHistoryItem__amount}>
                </div>
            </div>
        </div>;
};